import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const
  MemoriaLabores = lazy(() => import('../../../views/MemoriaLabores/index'))


const Index = (props: any) => {
  return (
    <Switch>
      <Route path={`${props.match.path}`} component={MemoriaLabores} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
